import type { Alert } from '@tunasong/models'

/**
 * GH #2950: a save the server refused with a 4xx (a WAF 403, a 403 from lost access, a 422, a 429) was only logged,
 * and the edit reverted with nothing shown. Not a 412: the conflict notice owns it (GH #1912). Not a 5xx or a
 * network failure: the offline mutation queue replays those, and the base query toasts a 5xx.
 */
export const isRefusedSave = (error: unknown) => {
  const status = (error as { status?: unknown } | null)?.status
  return typeof status === 'number' && status >= 400 && status < 500 && status !== 412
}

/**
 * Stays until dismissed: the edit has already reverted on screen, so this is the only trace of it. There is no
 * "Try again": the change is gone, so the message says to make it again. Copy: Brian, on the user's delegation.
 */
export const saveRefusedAlert: Alert = {
  severity: 'error',
  title: "Couldn't save your changes",
  message: 'The change was undone. Please make it again.',
  duration: null,
}
